import { render, staticRenderFns } from "./NavbarAvatar.vue?vue&type=template&id=a2d6c930&scoped=true"
import script from "./NavbarAvatar.vue?vue&type=script&lang=ts"
export * from "./NavbarAvatar.vue?vue&type=script&lang=ts"
import style0 from "./NavbarAvatar.vue?vue&type=style&index=0&id=a2d6c930&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d6c930",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2d6c930')) {
      api.createRecord('a2d6c930', component.options)
    } else {
      api.reload('a2d6c930', component.options)
    }
    module.hot.accept("./NavbarAvatar.vue?vue&type=template&id=a2d6c930&scoped=true", function () {
      api.rerender('a2d6c930', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/navbar/NavbarAvatar.vue"
export default component.exports